import { useState } from "react";
import { ImageIcon } from "lucide-react";
import { BILDER } from "../lib/inhalte";

// Gezeichnete Platzhalter-Böden für die Vorher-Nachher-Verwandlung, bis die Illustrationen da sind
const BODEN_ALT = {
  backgroundColor: "#6f6a62",
  backgroundImage: [
    "radial-gradient(ellipse 22% 14% at 28% 62%, rgba(25,20,15,0.55), transparent 70%)",
    "radial-gradient(ellipse 30% 10% at 70% 78%, rgba(20,18,15,0.45), transparent 70%)",
    "radial-gradient(ellipse 12% 20% at 82% 30%, rgba(160,150,135,0.5), transparent 70%)",
    "radial-gradient(ellipse 35% 25% at 45% 35%, rgba(140,128,110,0.6), transparent 70%)",
    "linear-gradient(115deg, transparent 48%, rgba(30,25,20,0.6) 49%, transparent 50.5%)",
    "linear-gradient(170deg, transparent 63%, rgba(30,25,20,0.5) 63.6%, transparent 64.5%)",
    "linear-gradient(180deg, #8a847a, #5d5850)",
  ].join(","),
};
const BODEN_NEU = {
  backgroundColor: "#9a9895",
  backgroundImage: [
    "radial-gradient(ellipse 60% 35% at 55% 20%, rgba(255,255,255,0.55), transparent 70%)",
    "radial-gradient(circle at 20% 70%, rgba(40,40,40,0.35) 0 1.5px, transparent 2px)",
    "radial-gradient(circle at 60% 40%, rgba(240,240,240,0.6) 0 1.5px, transparent 2px)",
    "radial-gradient(circle at 80% 80%, rgba(109,40,217,0.45) 0 1.5px, transparent 2px)",
    "linear-gradient(180deg, #b9b7b3, #8e8c88)",
  ].join(","),
  backgroundSize: "auto, 23px 23px, 31px 31px, 37px 37px, auto",
};

// Beispielbild (wenn vorhanden) oder Platzhalter mit Motivbeschreibung. Nie als Referenzprojekt beschriftet.
// Kein Vermerk auf den Bildern (Entscheid Nova 2026-10-22); Bilder werden nie als eigene Projekte beschriftet.
export const Bild = ({ id, className = "", platzhalter = "motiv" }) => {
  const b = BILDER[id];
  const [fehlt, setFehlt] = useState(false);          // Datei nicht vorhanden → Platzhalter statt kaputtem Bild
  if (b?.datei && !fehlt) {
    return (
      <div className={`relative overflow-hidden ${className}`}>
        <img src={b.datei} alt={b.motiv} loading="lazy" onError={() => setFehlt(true)}
          className="absolute inset-0 w-full h-full object-cover" />
      </div>
    );
  }
  if (platzhalter === "alt" || platzhalter === "neu") {
    return <div aria-hidden="true" className={className} style={platzhalter === "alt" ? BODEN_ALT : BODEN_NEU} />;
  }
  return (
    <div
      role="img"
      aria-label={b?.motiv || ""}
      className={`flex flex-col items-center justify-center gap-2 p-3 text-center bg-gradient-to-br from-stein-200 to-stein-300 text-stein-500 ${className}`}
    >
      <ImageIcon size={22} strokeWidth={1.5} />
      <span className="text-[11px] leading-snug max-w-[18ch]">{b?.motiv}</span>
    </div>
  );
};
